<script setup lang="ts">
import {computed, PropType} from "vue";
import {PillSize, PillTheme} from "./odsPill";
import {AsidePosition} from "../../tokens/";
import {odsIcon, IconName, IconSize} from "../../components/odsIcon";

const props = defineProps({
  theme: {
    type: String as PropType<typeof PillTheme[keyof typeof PillTheme]>,
    default: PillTheme.Default
  },
  label: {
    type: String,
    required: true,
  },
  size: {
    type: String as PropType<typeof PillSize[keyof typeof PillSize]>,
    default: PillSize.Small
  },
  rounded: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String as PropType<typeof IconName[keyof typeof IconName] | String>,
    default: ''
  },
  iconPosition: {
    type: String as PropType<typeof AsidePosition[keyof typeof AsidePosition]>,
    default: AsidePosition.Default
  }
})

const iconSize = computed(() => {
  switch (props.size) {
    case PillSize.Small:
      return IconSize.Medium;
    case PillSize.Medium:
      return IconSize.Medium
    case PillSize.Large:
      return IconSize.Default;
    default:
      return IconSize.Default;
  }
})

</script>

<template>
  <div class="ods-pill" :class="[`ods-pill-theme-${theme}`, `ods-pill-size-${size}`, {'ods-pill-rounded': rounded}]">
    <slot name="before">
      <odsIcon :name="icon" v-if="icon && iconPosition === AsidePosition.Before" :size="iconSize"/>
    </slot>
    <slot>
      <span class="label" v-if="label !== ''" v-html="label"/>
    </slot>
    <slot name="after">
      <odsIcon :name="icon" v-if="icon && iconPosition === AsidePosition.After" :size="iconSize"/>
    </slot>
  </div>
</template>

<style lang="scss" src="./odsPill.scss"/>